import { currentUserService } from "../services/currentUser.service";
import {
  userConstants,
  userNameSpace,
  permissionConstants,
  permissionsNameSpace
} from "../constants/currentUser.constants";

export const getCurrentUser = () => {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await currentUserService.getCurrentUser();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
    }
  };

  function request() {
    return { type: userConstants[`GET_${userNameSpace}_REQUEST`] };
  }
  function success(response) {
    return { type: userConstants[`GET_${userNameSpace}_SUCCESS`], response };
  }
  function failure(error) {
    return { type: userConstants[`GET_${userNameSpace}_FAILURE`], error };
  }
};

export const getPermissions = () => {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await currentUserService.getPermissions();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
    }
  };

  function request() {
    return { type: permissionConstants[`GET_${permissionsNameSpace}_REQUEST`] };
  }
  function success(response) {
    return {
      type: permissionConstants[`GET_${permissionsNameSpace}_SUCCESS`],
      response
    };
  }
  function failure(error) {
    return {
      type: permissionConstants[`GET_${permissionsNameSpace}_FAILURE`],
      error
    };
  }
};
